module.exports = __webpack_public_path__ + "d661601f49107583b847bdb0ebc03c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/Y@2x.png
// module id = 840
// module chunks = 0